/**
 * Order service API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RfqNegotiationShared } from './rfqNegotiationShared';


export interface RequestQuotationShared { 
    id?: number;
    skuId?: number;
    negotiation?: RfqNegotiationShared;
    description?: string;
    buyerId?: number;
    sellerId?: number;
    startPrice?: number;
    quantity?: number;
    status?: RequestQuotationShared.StatusEnum;
    buyerStatus?: RequestQuotationShared.BuyerStatusEnum;
    merchantStatus?: RequestQuotationShared.MerchantStatusEnum;
    orderId?: number;
    chatId?: number;
    createdAt?: Date;
}
export namespace RequestQuotationShared {
    export type StatusEnum = 'ACTIVE' | 'AWAITING_SELLER' | 'AWAITING_BUYER' | 'ACCEPTED' | 'FINISHED' | 'CLOSED';
    export const StatusEnum = {
        ACTIVE: 'ACTIVE' as StatusEnum,
        AWAITING_SELLER: 'AWAITING_SELLER' as StatusEnum,
        AWAITING_BUYER: 'AWAITING_BUYER' as StatusEnum,
        ACCEPTED: 'ACCEPTED' as StatusEnum,
        FINISHED: 'FINISHED' as StatusEnum,
        CLOSED: 'CLOSED' as StatusEnum
    };
    export type BuyerStatusEnum = 'NEW' | 'VIEW_LATER' | 'CONTACT_TO_CUSTOMER' | 'NOT_INTERESTED';
    export const BuyerStatusEnum = {
        NEW: 'NEW' as BuyerStatusEnum,
        VIEW_LATER: 'VIEW_LATER' as BuyerStatusEnum,
        CONTACT_TO_CUSTOMER: 'CONTACT_TO_CUSTOMER' as BuyerStatusEnum,
        NOT_INTERESTED: 'NOT_INTERESTED' as BuyerStatusEnum
    };
    export type MerchantStatusEnum = 'NEW' | 'VIEW_LATER' | 'CONTACT_TO_CUSTOMER' | 'NOT_INTERESTED';
    export const MerchantStatusEnum = {
        NEW: 'NEW' as MerchantStatusEnum,
        VIEW_LATER: 'VIEW_LATER' as MerchantStatusEnum,
        CONTACT_TO_CUSTOMER: 'CONTACT_TO_CUSTOMER' as MerchantStatusEnum,
        NOT_INTERESTED: 'NOT_INTERESTED' as MerchantStatusEnum
    };
}


